// comment
// comment
// comment
// comment
// comment
// comment


class ProductInformation extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.handleEvents();
    this.mediaTagListeners = new Map();
    this.handleActionPopup();
  }

  connectedCallback() {
    if (this.querySelector(".pinfo-gallery-swiper")) this.initSwiperSlider();

    // this.querySelector("pinfo-variant-picker").addEventListener(
    //   "input",
    //   this.handleVariantEvent.bind(this)
    // );


    this.querySelector("pinfo-variant-picker")?.addEventListener(
      "input",
      this.handleVariantEvent.bind(this)
    );

    
    // this.initZoomSlider();
    this.accordionInit();
    this.initMobileSwiper();
    this.verticalImageChange();
    this.customCursor();
    this.mediaPopup();
    this.colorLabelHover();
    this.optionLabelHover();
    this.initQuantitySelector();
    this.initShopTheLookScroll();
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this)); 
    setTimeout(() => {
      // window.handleKachingBundle();
    }, 500);

    // ============================================================
    // INIT STICKY MOBILE PREVIEW
    // ============================================================
    this.initStickyMobilePreview();

  }

  handleCartUpdate(e) {
    this.initProgressTracker();
  }

initProgressTracker() {
  // Store the blocks reference
  this.progressTrackerBlocks = this.querySelectorAll('[data-progress-section]');
  if (!this.progressTrackerBlocks.length) return;
  this.updateProgressTracker();
}

updateProgressTracker() {
  var self = this;
  if (!this.sectionId) return;

  var url = new URL(window.location.href);
  url.searchParams.set('section_id', this.sectionId);

  fetch(url.toString())
    .then(function(response) { return response.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      self.progressTrackerBlocks.forEach(function(currentBlock) {
        var blockId = currentBlock.dataset.blockId;
        var selector = blockId
          ? '[data-progress-section][data-block-id="' + blockId + '"]'
          : '[data-progress-section]';
        var newBlock = doc.querySelector(selector);
        if (newBlock) {
          currentBlock.innerHTML = newBlock.innerHTML;
        }
      });
    })
    .catch(function(error) {
      console.error('Error updating progress tracker:', error);
    });
}


  /*
  initProgressTracker() {
    this.progressTrackerBlock = this.querySelector('[data-progress-section]');
    if (!this.progressTrackerBlock) return;
    
    this.updateProgressTracker();
  }

  updateProgressTracker() {
    if (!this.sectionId) return;
    
    fetch('/?section_id=' + this.sectionId)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newBlock = doc.querySelector('[data-progress-section]');
        if (newBlock && this.progressTrackerBlock) {
          this.progressTrackerBlock.innerHTML = newBlock.innerHTML;
        }
      })
      .catch(error => console.error('Error updating progress tracker:', error));
  }
  */



  disconnectedCallback() {
    // Clean up sticky preview
    if (this._stickyCleanup) {
      this._stickyCleanup();
    }

    // Clean up media tag listeners
    if (this.mediaTagListeners) {
      this.mediaTagListeners.forEach((listeners, element) => {
        element.removeEventListener('mouseenter', listeners.mouseenter);
        element.removeEventListener('mousemove', listeners.mousemove);
        element.removeEventListener('mouseleave', listeners.mouseleave);
      });
      this.mediaTagListeners.clear();
    }

    // Clean up bound event handlers
    if (this._boundHandleAddToCart) {
      const form = this.querySelector('form[action$="/cart/add"]');
      if (form) {
        form.removeEventListener('submit', this._boundHandleAddToCart);
      }
    }

    // Destroy Swiper instances
    if (this.mobileSwiper) {
      this.mobileSwiper.destroy(true, true);
      this.mobileSwiper = null;
    }
    if (this.thumbSwiper) {
      this.thumbSwiper.destroy(true, true);
      this.thumbSwiper = null;
    }
    if (this.gallerySwiper) {
      this.gallerySwiper.destroy(true, true);
      this.gallerySwiper = null;
    }

    // Remove any sticky overlays
    const overlay = document.querySelector('.sticky-overlay');
    if (overlay) {
      overlay.remove();
    }

    // Remove body class
    document.body.classList.remove('sticky-active');

    console.log('[ProductInformation] Cleaned up');
  }


  // ============================================================
  // MOBILE MONOGRAM PREVIEW STICKY BEHAVIOR
  // ============================================================

  initStickyMobilePreview() {
    if (window.innerWidth > 989) return;

    const mainSwiperWrapper = document.querySelector('.pdp-media-sm .main-swiper-wrapper');
    const customPlacementWrapper = document.querySelector('.cpc-placement-wrapper.cpc-placement-block-wrapper');
    const body = document.body;

    if (!mainSwiperWrapper || !customPlacementWrapper) {
      console.log('[Sticky Preview] Required elements not found');
      return;
    }

    const hasMonogram = !!document.querySelector('.cpc-placement-wrapper');
    if (!hasMonogram) {
      console.log('[Sticky Preview] No monogram customizer found');
      return;
    }

    function isMonogramSlideActive() {
      const monogramSlide = document.querySelector('.swiper-slide.cpc-monogram-slide-wrapper');
      if (!monogramSlide) return false;
      
      return monogramSlide.classList.contains('swiper-slide-active');
    }

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function doesMonogramSlideExist() {
      return !!document.querySelector('.swiper-slide.cpc-monogram-slide-wrapper');
    }

    function isAtTopOfPage() {
      return window.scrollY <= 50; 
    }

    let isSticky = false;
    let scrollTimeout = null;

    function setSticky(shouldSticky) {
      if (shouldSticky === isSticky) return;
      
      isSticky = shouldSticky;

      if (isSticky) {
        mainSwiperWrapper.classList.add('sticky-preview');
        body.classList.add('sticky-monogram-active');
        console.log('[Sticky Preview] Activated');
      } else {
        mainSwiperWrapper.classList.remove('sticky-preview');
        body.classList.remove('sticky-monogram-active');
        console.log('[Sticky Preview] Deactivated');
      }
    }

    function handleScroll() {
      if (window.innerWidth > 989) {
        setSticky(false);
        return;
      }

      if (scrollTimeout) {
        cancelAnimationFrame(scrollTimeout);
      }

      scrollTimeout = requestAnimationFrame(() => {
        const atTop = isAtTopOfPage();
        
        const slideExists = doesMonogramSlideExist();
        
        const slideActive = isMonogramSlideActive();
        
        const isInViewport = isElementInViewport(customPlacementWrapper);

        const shouldBeSticky = !atTop && slideExists && slideActive && isInViewport;

        setSticky(shouldBeSticky);
        
      });
    }

    function handleResize() {
      if (window.innerWidth > 989) {
        setSticky(false);
      } else {
        handleScroll();
      }
    }

    function setupSwiperListeners() {
      const mainSwiperEl = document.querySelector('.pdp-media-sm .main-swiper');
      if (mainSwiperEl && mainSwiperEl.swiper) {
        if (mainSwiperEl._stickySlideChangeHandler) {
          mainSwiperEl.swiper.off('slideChange', mainSwiperEl._stickySlideChangeHandler);
        }
        
        mainSwiperEl._stickySlideChangeHandler = function() {
          handleScroll();
        };
        
        mainSwiperEl.swiper.on('slideChange', mainSwiperEl._stickySlideChangeHandler);
        
        mainSwiperEl._stickySlideEndHandler = function() {
          setTimeout(handleScroll, 50);
        };
        
        mainSwiperEl.swiper.on('slideChangeTransitionEnd', mainSwiperEl._stickySlideEndHandler);
        
        console.log('[Sticky Preview] Swiper listeners attached');
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });

    setTimeout(setupSwiperListeners, 500);

    const swiperObserver = new MutationObserver(() => {
      setupSwiperListeners();
    });

    const mainSwiperEl = document.querySelector('.pdp-media-sm .main-swiper');
    if (mainSwiperEl) {
      swiperObserver.observe(mainSwiperEl, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    const placementObserver = new MutationObserver(() => {
      handleScroll();
    });

    if (customPlacementWrapper) {
      placementObserver.observe(customPlacementWrapper, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    document.addEventListener('monogram:updated', () => {
      setTimeout(handleScroll, 100);
    });

    setTimeout(handleScroll, 600);

    this._stickyCleanup = function() {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
      placementObserver.disconnect();
      swiperObserver.disconnect();
      
      const mainSwiperEl = document.querySelector('.pdp-media-sm .main-swiper');
      if (mainSwiperEl && mainSwiperEl.swiper) {
        if (mainSwiperEl._stickySlideChangeHandler) {
          mainSwiperEl.swiper.off('slideChange', mainSwiperEl._stickySlideChangeHandler);
          mainSwiperEl._stickySlideChangeHandler = null;
        }
        if (mainSwiperEl._stickySlideEndHandler) {
          mainSwiperEl.swiper.off('slideChangeTransitionEnd', mainSwiperEl._stickySlideEndHandler);
          mainSwiperEl._stickySlideEndHandler = null;
        }
      }
      
      setSticky(false);
      body.classList.remove('sticky-monogram-active');
      console.log('[Sticky Preview] Cleaned up');
    };

    console.log('[Sticky Preview] Initialized');
  }

  handleVariantEvent(e) {
    const { variantUrl } = e.target.dataset;
    const isColorInput = e.target.classList.contains("pinfo-color-input");

    const cursor = document.querySelector('.custom-cursor');
    if (cursor) cursor.remove();
    this.cleanupCustomCursor();

    this.handleOptions(variantUrl, isColorInput);
    // this.handleOptions(variantUrl);
    // const variantId = new URLSearchParams(variantUrl.split("?")[1]).get("variant");
    const variantId = Number(
      new URLSearchParams(variantUrl.split("?")[1]).get("variant")
    );


    // console.log(variantId);
    // let selectedVariant = productVariants.find((v) => v.id === variantId);
    // console.log(productVariants);
    // console.log(selectedVariant);
    // if (document.querySelector("stock-notify")) {
    //   notifyPopup(selectedVariant);
    // }
  }

initShopTheLookScroll() {
  const anchors = this.querySelectorAll(".--shop-the-look-anchor");

  if (!anchors || anchors.length === 0) return;

  anchors.forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault();

      const customProductSection = document.querySelector('#--custom-product-section');

      if (customProductSection) {
        const sectionRect = customProductSection.getBoundingClientRect();
        const sectionBottomAbsolute = window.pageYOffset + sectionRect.bottom;

        window.scrollTo({
          top: Math.max(0, sectionBottomAbsolute - window.innerHeight - 150),
          behavior: "smooth"
        });
      }
    });
  });
}

  handleActionPopup() {
    const openButtons = this.querySelectorAll("[open-action-popup]");
    const closeButtons = this.querySelectorAll("[close-action-popup]");
    const popup = this.querySelector(".action__popup");
    const body = document.body;
    let isProcessing = false;

    const waitForTransition = (element, property) => {
      return new Promise((resolve) => {
        const handler = (e) => {
          if (
            e.target === element &&
            (!property || e.propertyName === property)
          ) {
            element.removeEventListener("transitionend", handler);
            resolve();
          }
        };
        element.addEventListener("transitionend", handler);
        setTimeout(resolve, 1000);
      });
    };

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    const openPopup = async () => {
      if (isProcessing || popup.classList.contains("active")) return;
      isProcessing = true;

      const existingOverlay = document.querySelector(".custom-overlay-see-action");
      if (existingOverlay) existingOverlay.remove();
      const overlay = document.createElement("div");
      overlay.className = "custom-overlay-see-action";
      document.body.appendChild(overlay);

      overlay.classList.add("active");
      await waitForTransition(overlay, "opacity");

      popup.classList.add("active");
      await waitForTransition(popup, "max-height");

      closeButtons.forEach((btn) => btn.classList.add("visible"));
      await waitForTransition(closeButtons[0], "opacity");

      await delay(150);
      body.classList.add("overflow-hidden");

      await delay(150);
      const video = popup.querySelector(".action-video");
      if (video) {
        video.currentTime = 0;
        video.play().catch((error) => console.log("Video play failed:", error));
      }

      isProcessing = false;
    };

    const closePopup = async () => {
      if (isProcessing || !popup.classList.contains("active")) return;
      isProcessing = true;

      const video = popup.querySelector(".action-video");
      if (video) video.pause();

      popup.classList.remove("active");
      await waitForTransition(popup, "max-height");

      closeButtons.forEach((btn) => btn.classList.remove("visible"));
      await waitForTransition(closeButtons[0], "opacity");

      await delay(150);
      body.classList.remove("overflow-hidden");

      const overlay = document.querySelector(".custom-overlay-see-action");
      if (overlay) {
        overlay.classList.remove("active");
        await waitForTransition(overlay, "opacity");
        overlay.remove();
      }

      isProcessing = false;
    };

    openButtons.forEach((button) => {
      button.addEventListener("click", openPopup);
    });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closePopup);
    });

    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("custom-overlay-see-action")) {
        closePopup();
      }
    });
  }



  initQuantitySelector() {
    const qtyWrapper = this.querySelector('[data-quantity-selector]');
    if (!qtyWrapper) return;
    
    // Remove any existing event listeners by cloning the wrapper
    const newQtyWrapper = qtyWrapper.cloneNode(true);
    qtyWrapper.parentNode.replaceChild(newQtyWrapper, qtyWrapper);
    
    // Get fresh references
    const freshWrapper = this.querySelector('[data-quantity-selector]');
    const input = freshWrapper.querySelector('.qty-input');
    const decreaseBtn = freshWrapper.querySelector('.decrease');
    const increaseBtn = freshWrapper.querySelector('.increase');
    
    // Use a single event listener approach with delegation
    // This is cleaner and avoids multiple listeners
    const handler = (e) => {
      const target = e.target;
      if (target.classList.contains('decrease')) {
        let currentVal = parseInt(input.value) || 1;
        if (currentVal > parseInt(input.min || 1)) {
          input.value = currentVal - 1;
          this.dispatchQuantityChange(input.value);
        }
      } else if (target.classList.contains('increase')) {
        let currentVal = parseInt(input.value) || 1;
        input.value = currentVal + 1;
        this.dispatchQuantityChange(input.value);
      } else if (target.classList.contains('qty-input')) {
        if (input.value < 1) input.value = 1;
        this.dispatchQuantityChange(input.value);
      }
    };
    
    // Add a single listener to the wrapper using event delegation
    freshWrapper.addEventListener('click', handler);
    freshWrapper.addEventListener('input', handler);
    
    // Store reference for cleanup
    this._quantityHandler = handler;
  }



  dispatchQuantityChange(value) {
    this.dispatchEvent(new CustomEvent('quantity-change', {
      detail: { quantity: Number(value) },
      bubbles: true
    }));
  }

  
  colorLabelHover() {
    const selectedColor = this.querySelector('.pinfo-selected-color');
    if (!selectedColor) return;
    const originalText = selectedColor.textContent;
    this.querySelectorAll('.pinfo-color-label').forEach((label) => {
      label.addEventListener('mouseenter', () => {
        const title = label.getAttribute('title');
        if (title) selectedColor.textContent = title;
      });
      label.addEventListener('mouseleave', () => {
        selectedColor.textContent = originalText;
      });
    });
  }
  

  /*
  colorLabelHover() {
    const selectedColorElements = this.querySelectorAll('.pinfo-selected-color');
    
    if (!selectedColorElements.length) return;

    const originalTexts = {};
    selectedColorElements.forEach((el) => {
      const groupLabel = el.closest('.pinfo-option-label-wrapper')?.querySelector('.pinfo-filter-label span:first-child')?.textContent?.trim() || 'color';
      const key = groupLabel.toLowerCase();
      originalTexts[key] = el.textContent.trim();
    });

    this.querySelectorAll('.pinfo-color-label').forEach((label) => {
      label.addEventListener('mouseenter', () => {
        const groupContainer = label.closest('.color-group-container');
        let selectedColor = null;
        
        if (groupContainer) {
          selectedColor = groupContainer.querySelector('.pinfo-selected-color');
        } else {
          selectedColor = this.querySelector('.pinfo-selected-color');
        }
        
        if (selectedColor) {
          const title = label.getAttribute('title');
          if (title) selectedColor.textContent = title;
        }
      });

      label.addEventListener('mouseleave', () => {
        const groupContainer = label.closest('.color-group-container');
        let selectedColor = null;
        
        if (groupContainer) {
          selectedColor = groupContainer.querySelector('.pinfo-selected-color');
        } else {
          selectedColor = this.querySelector('.pinfo-selected-color');
        }
        
        if (selectedColor) {
          const groupLabel = selectedColor.closest('.pinfo-option-label-wrapper')?.querySelector('.pinfo-filter-label span:first-child')?.textContent?.trim() || 'color';
          const key = groupLabel.toLowerCase();
          selectedColor.textContent = originalTexts[key] || selectedColor.textContent;
        }
      });
    });
  }
  */
  
  optionLabelHover() {
    const selectedOption = this.querySelector('[data-dynamic-size-label]');
    // if (!selectedOption) return;
    const originalText = selectedOption?.textContent;
    this.querySelectorAll('.pinfo-options-values-wrapper.others-options .pinfo-option-value').forEach((label) => {
      let selectedOption2 =  label.closest('.pinfo-variants-options')?.querySelector('span.pinfo-selected-value');
      if (!selectedOption2) return;
      let originalText2 = selectedOption2.textContent; 
      label.addEventListener('mouseenter', () => {

        const title = label.querySelector('label').getAttribute('title');
        // if (title) selectedOption.textContent = title;
        if (title) selectedOption2.textContent = title;
      });
      label.addEventListener('mouseleave', () => {
        // selectedOption.textContent = originalText;
        selectedOption2.textContent = originalText2;
      });
    });
  }

  verticalImageChange() {
    this.verticalImages = this.querySelectorAll(".vertical__media");
    this.galleryImages = this.querySelectorAll(".info-media-stack-wrapper .pdp-media");

    if (this.verticalImages.length > 0) {
      this.verticalImages[0].classList.add("active");
    }

    this.verticalImages.forEach((verticalImage) => {
      verticalImage.addEventListener("click", () => {
        this.verticalImages.forEach((img) => img.classList.remove("active"));
        verticalImage.classList.add("active");

        const mediaContainer = verticalImage.closest(".pdp-media-v");
        if (!mediaContainer) return;
        const mediaId = mediaContainer.dataset.media;

        const matchedGalleryImage = Array.from(this.galleryImages).find(
          (galleryImage) => galleryImage.dataset.media === mediaId
        );

        if (matchedGalleryImage) {
          const parent = matchedGalleryImage.parentNode;
          parent.prepend(matchedGalleryImage);
        }
      });
    });
  }

 cleanupCustomCursor() {
    this.mediaTagListeners.forEach((listeners, element) => {
      element.removeEventListener('mouseenter', listeners.mouseenter);
      element.removeEventListener('mousemove', listeners.mousemove);
      element.removeEventListener('mouseleave', listeners.mouseleave);
    });
    this.mediaTagListeners.clear();
  }

  checkQuickViewAncestor() {
    return !!this.closest('.pqv-container');
  }

  customCursor() {
    if (window.matchMedia("(max-width: 989px)").matches) return;
    if (this.checkQuickViewAncestor()) return; 
    let cursor = null;
    const createCustomCursor = (e) => {
      cursor = document.createElement('div');
      cursor.className = 'custom-cursor';
      cursor.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
          <g clip-path="url(#clip0_17224_10739)">
            <path d="M14.8078 12.61L15.0308 13.4545L15.8753 13.6775L17.0955 14L15.8753 14.3225L15.0308 14.5455L14.8078 15.39L14.4846 16.6109L14.1628 15.39L13.9398 14.5455L13.0952 14.3225L11.8737 14L13.0952 13.6775L13.9398 13.4545L14.1628 12.61L14.4846 11.3891L14.8078 12.61Z" stroke="white" stroke-width="3"/>
            <path d="M8.16699 1.16666H2.33366C1.68933 1.16666 1.16699 1.68899 1.16699 2.33332V8.16666" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M19.834 26.8333H25.6673C26.3117 26.8333 26.834 26.3109 26.834 25.6666V19.8333" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M26.834 8.1666V2.33326C26.834 1.68893 26.3116 1.1666 25.6673 1.1666H19.834" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
            <path d="M1.16699 19.8333V25.6666C1.16699 26.3109 1.68933 26.8333 2.33366 26.8333H8.16699" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          </g>
          <defs>
            <clipPath id="clip0_17224_10739">
              <rect width="28" height="28" fill="white"/>
            </clipPath>
          </defs>
        </svg>
        <span class="cursor-text hidden">Zoom In</span>
      `;
      document.body.appendChild(cursor);
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    };
    const updateCursorPosition = (e) => {
      if (cursor) {
        requestAnimationFrame(() => {
          cursor.style.left = `${e.clientX}px`;
          cursor.style.top = `${e.clientY}px`;
        });
      }
    };
    const destroyCustomCursor = () => {
      if (cursor) {
        cursor.remove();
        cursor = null;
      }
    };
    this.querySelectorAll('.pdp__media-tag').forEach((element) => {
      element.classList.add('no-cursor');
      const listeners = {
        mouseenter: createCustomCursor,
        mousemove: updateCursorPosition,
        mouseleave: destroyCustomCursor
      };
      element.addEventListener('mouseenter', listeners.mouseenter);
      element.addEventListener('mousemove', listeners.mousemove);
      element.addEventListener('mouseleave', listeners.mouseleave);
      this.mediaTagListeners.set(element, listeners);
    });
  }

/*
mediaPopup() {
  if (this.checkQuickViewAncestor()) return;
  
  const getVisibleMediaContainer = () => {
    const desktopContainer = this.querySelector('.stack___pdp-container-wrap');
    const mobileContainer = this.querySelector('.pdp-media-sm');
    
    if (mobileContainer && window.getComputedStyle(mobileContainer).display !== 'none') {
      return mobileContainer;
    } else if (desktopContainer && window.getComputedStyle(desktopContainer).display !== 'none') {
      return desktopContainer;
    }
    
    return window.innerWidth < 990 ? mobileContainer : desktopContainer;
  };
  
  this.querySelectorAll('.pdp__media-tag').forEach((media) => {
    media.addEventListener('click', () => {
      const visibleContainer = getVisibleMediaContainer();
      const visibleMedia = visibleContainer ? 
        Array.from(visibleContainer.querySelectorAll('.pdp__media-tag')) : 
        Array.from(this.querySelectorAll('.pdp__media-tag'));
      
      const clickedIndex = visibleMedia.indexOf(media);
      
      if (clickedIndex !== -1) {
        this.openSliderPopup(clickedIndex, visibleMedia);
      }
    });
  });
}
*/

/*
mediaPopup() {
  if (this.checkQuickViewAncestor()) return;

  const getVisibleMediaContainer = () => {
    const desktopContainer = this.querySelector('.stack___pdp-container-wrap');
    const mobileContainer = this.querySelector('.pdp-media-sm');

    if (mobileContainer && window.getComputedStyle(mobileContainer).display !== 'none') {
      return mobileContainer;
    } else if (desktopContainer && window.getComputedStyle(desktopContainer).display !== 'none') {
      return desktopContainer;
    }

    return window.innerWidth < 990 ? mobileContainer : desktopContainer;
  };

  this.querySelectorAll('.pdp__media-tag').forEach((media) => {
    if (media._mediaPopupHandler) {
      media.removeEventListener('click', media._mediaPopupHandler);
    }

    media._mediaPopupHandler = () => {
      const visibleContainer = getVisibleMediaContainer();
      const visibleMedia = visibleContainer ?
        Array.from(visibleContainer.querySelectorAll('.pdp__media-tag')) :
        Array.from(this.querySelectorAll('.pdp__media-tag'));

      const clickedIndex = visibleMedia.indexOf(media);

      if (clickedIndex !== -1) {
        this.openSliderPopup(clickedIndex, visibleMedia);
      }
    };

    media.addEventListener('click', media._mediaPopupHandler);
  });
}
*/


mediaPopup() {
  if (this.checkQuickViewAncestor()) return;

  const getVisibleMediaContainer = () => {
    const desktopContainer = this.querySelector('.stack___pdp-container-wrap');
    const mobileContainer = this.querySelector('.pdp-media-sm');

    if (mobileContainer && window.getComputedStyle(mobileContainer).display !== 'none') {
      return mobileContainer;
    } else if (desktopContainer && window.getComputedStyle(desktopContainer).display !== 'none') {
      return desktopContainer;
    }

    return window.innerWidth < 990 ? mobileContainer : desktopContainer;
  };

  this.querySelectorAll('.pdp__media-tag').forEach((media) => {
    if (media._mediaPopupHandler) {
      media.removeEventListener('click', media._mediaPopupHandler);
    }

    media._mediaPopupHandler = () => {
      const visibleContainer = getVisibleMediaContainer();
      let visibleMedia = visibleContainer ?
        Array.from(visibleContainer.querySelectorAll('.pdp__media-tag')) :
        Array.from(this.querySelectorAll('.pdp__media-tag'));

      const desktopContainer = this.querySelector('.stack___pdp-container-wrap');
      const mobileContainer = this.querySelector('.pdp-media-sm');

      const isCustomizerActive = 
        (desktopContainer && desktopContainer.querySelector('.customizer-preview-active')) &&
        (mobileContainer && mobileContainer.classList.contains('customizer-preview-active'));

      const hasPreviewImage = visibleMedia.some(m => m.closest('.customizer-preview-image'));

      if (isCustomizerActive && visibleMedia.length === 2 && hasPreviewImage) {
        visibleMedia = [visibleMedia[0]];
      }

      let clickedIndex = visibleMedia.indexOf(media);

      if (isCustomizerActive && clickedIndex === -1 && visibleMedia.length === 1) {
        clickedIndex = 0;
      }

      if (clickedIndex !== -1) {
        this.openSliderPopup(clickedIndex, visibleMedia);
      }
    };

    media.addEventListener('click', media._mediaPopupHandler);
  });
}

openSliderPopup(initialIndex, mediaArray) {
  console.log(mediaArray);
  const uniqueId = `slider-${Date.now()}`;
  
  document.body.style.overflow = 'hidden';

  const sliderPopup = document.createElement('div');
  sliderPopup.className = 'slider-popup-overlay';

  const sliderContent = document.createElement('div');
  sliderContent.className = 'slider-popup-content';

  const sliderCloseBtn = document.createElement('button');
  sliderCloseBtn.className = 'slider-popup-close';
  sliderCloseBtn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-minus" width="16" height="16" viewBox="0 0 8 8" fill="none">
      <path d="M7.23248 1.57393L4.80812 3.99829L7.23248 6.42266L6.42436 7.23078L3.99999 4.80641L1.57563 7.23078L0.767506 6.42266L3.19187 3.99829L0.767506 1.57392L1.57563 0.765803L3.99999 3.19017L6.42436 0.765803L7.23248 1.57393Z" fill="#6C7884"></path>
    </svg>
  `;

  const mainSwiperContainer = document.createElement('div');
  mainSwiperContainer.className = 'media-slider-swiper swiper';
  mainSwiperContainer.id = `main-${uniqueId}`;

  const mainSwiperWrapper = document.createElement('div');
  mainSwiperWrapper.className = 'swiper-wrapper';

  const thumbSwiperContainer = document.createElement('div');
  thumbSwiperContainer.className = 'media-slider-thumb-swiper swiper';
  thumbSwiperContainer.id = `thumb-${uniqueId}`;

  const thumbSwiperWrapper = document.createElement('div');
  thumbSwiperWrapper.className = 'swiper-wrapper';

  const allMedia = mediaArray;
  
  allMedia.forEach((mediaItem, index) => {
    const mainSlide = document.createElement('div');
    mainSlide.className = 'swiper-slide media-slider-slide';
    mainSlide.dataset.mediaIndex = index;
    
    const mainClone = mediaItem.cloneNode(true);
    mainClone.className = 'slider-media-item';
    
    mainSlide.appendChild(mainClone);
    mainSwiperWrapper.appendChild(mainSlide);

    const thumbSlide = document.createElement('div');
    thumbSlide.className = 'swiper-slide media-slider-thumb-slide';
    thumbSlide.dataset.mediaIndex = index;
    
    const thumbClone = mediaItem.cloneNode(true);
    thumbClone.className = 'slider-thumb-item';
    
    thumbSlide.appendChild(thumbClone);
    thumbSwiperWrapper.appendChild(thumbSlide);
  });

  mainSwiperContainer.appendChild(mainSwiperWrapper);
  thumbSwiperContainer.appendChild(thumbSwiperWrapper);

  const navWrapper = document.createElement('div');
  navWrapper.className = 'slider-nav-wrapper';

  const prevButton = document.createElement('div');
  prevButton.className = 'swiper-button-prev media-slider-prev';
  prevButton.id = `prev-${uniqueId}`;
  prevButton.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 12" height="12" width="6">
  <path fill="#FFF" d="M5.22363 12L4.72193 11.7746L0.00140095 6.00163L6.77109e-05 6L0.00140095 5.99837L4.72193 0.225367L5.22363 0L2.56225 5.99837L2.56171 5.99973V6.00027L2.56225 6.00163L5.22363 12Z"></path>
  </svg>
  `;
  
  const nextButton = document.createElement('div');
  nextButton.className = 'swiper-button-next media-slider-next';
  nextButton.id = `next-${uniqueId}`;
  nextButton.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 12" height="12" width="6">
    <path fill="#FFF" d="M0.776367 0L1.27807 0.225368L5.9986 5.99837L5.99993 6L5.9986 6.00163L1.27807 11.7746L0.776367 12L3.43775 6.00163L3.43829 6.00027L3.43829 5.99973L3.43775 5.99837L0.776367 0Z"></path>
    </svg>
  `;

  navWrapper.appendChild(prevButton);
  navWrapper.appendChild(nextButton);
  mainSwiperContainer.appendChild(navWrapper);

  sliderContent.appendChild(sliderCloseBtn);
  sliderContent.appendChild(mainSwiperContainer);
  sliderContent.appendChild(thumbSwiperContainer);
  sliderPopup.appendChild(sliderContent);
  document.body.appendChild(sliderPopup);

  const thumbSwiper = new Swiper(thumbSwiperContainer, {
    slidesPerView: "auto",
    watchSlidesProgress: true,
    freeMode: true,
    loop: true,
    // breakpoints: {
    //   480: { slidesPerView: 4 },
    //   768: { slidesPerView: 5 },
    //   990: { slidesPerView: 6 },
    //   1300: { slidesPerView: 8 },
    // },
  });

  const mediaSliderSwiper = new Swiper(mainSwiperContainer, {
    slidesPerView: 1,
    initialSlide: initialIndex,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    thumbs: {
      swiper: thumbSwiper,
    },
    breakpoints: {
      600: { slidesPerView: 1, centeredSlides: true },
      600: { slidesPerView: 2, centeredSlides: true },
      990: { slidesPerView: 2, centeredSlides: true },
      1300: { slidesPerView: 3, centeredSlides: true },
    },
  });

  const closeSliderPopup = () => {
    document.body.style.overflow = '';
    sliderPopup.remove();
    if (mediaSliderSwiper) mediaSliderSwiper.destroy(true, true);
    if (thumbSwiper) thumbSwiper.destroy(true, true);
  };

  sliderCloseBtn.addEventListener('click', closeSliderPopup);

  sliderPopup.addEventListener('click', (e) => {
    if (!mainSwiperContainer.contains(e.target) && !thumbSwiperContainer.contains(e.target)) {
      closeSliderPopup();
    }
  });

  const mainSlides = mainSwiperContainer.querySelectorAll('.swiper-slide');
  mainSlides.forEach((slide) => {
    slide.addEventListener('click', () => {
      const actualIndex = slide.dataset.mediaIndex;
      if (actualIndex !== undefined) {
        this.openZoomPopup(allMedia[parseInt(actualIndex)], sliderPopup, mediaSliderSwiper);
      }
    });
  });
}

openZoomPopup(media, sliderPopup, mediaSliderSwiper) {
  const popup = document.createElement('div');
  popup.className = 'popup-overlay';

  const content = document.createElement('div');
  content.className = 'popup-content';

  const mediaWrapper = document.createElement('div');
  mediaWrapper.className = 'media-wrapper';

  const clone = media.cloneNode(true);
  clone.className = 'popup-media';
  if (media.tagName === 'VIDEO') {
    return;
    clone.controls = true;
    clone.autoplay = true;
  } else if (media.tagName === 'IMG') {
    const highResSrc = media.dataset.highResSrc || media.src.replace(/width=\d+/, 'width=2048');
    mediaWrapper.style.backgroundImage = `url(${highResSrc})`;
  }

  mediaWrapper.appendChild(clone);
  content.appendChild(mediaWrapper);

  const closeBtn = document.createElement('button');
  closeBtn.className = 'popup-close';
  closeBtn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-minus" width="16" height="16" viewBox="0 0 8 8" fill="none">
      <path d="M7.23248 1.57393L4.80812 3.99829L7.23248 6.42266L6.42436 7.23078L3.99999 4.80641L1.57563 7.23078L0.767506 6.42266L3.19187 3.99829L0.767506 1.57392L1.57563 0.765803L3.99999 3.19017L6.42436 0.765803L7.23248 1.57393Z" fill="#6C7884"></path>
    </svg>
  `;
  content.appendChild(closeBtn);

  popup.appendChild(content);
  document.body.appendChild(popup);

  let popupCursor = null;
  let initialPinchDistance = null;
  let initialBackgroundSize = 160;
  let currentBackgroundSize = initialBackgroundSize;
  let lastX = 50;
  let lastY = 50;
  let prevTouchX = null;
  let prevTouchY = null;

  const createPopupCursor = (e) => {
    popupCursor = document.createElement('div');
    popupCursor.className = 'popup-cursor';
    popupCursor.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <g clip-path="url(#clip0_17653_77081)">
          <path d="M15.6963 13.2451L15.2568 14L15.6963 14.7549L16.3311 15.8457L15.2402 15.2109L14.4854 14.7715L13.7305 15.2109L12.6387 15.8457L13.2744 14.7549L13.7139 14L13.2744 13.2451L12.6387 12.1533L13.7305 12.7891L14.4854 13.2285L15.2402 12.7891L16.3311 12.1533L15.6963 13.2451Z" stroke="white" stroke-width="3"/>
          <path d="M8.16699 1.16666H2.33366C1.68933 1.16666 1.16699 1.68899 1.16699 2.33332V8.16666" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M19.834 26.8333H25.6673C26.3117 26.8333 26.834 26.3109 26.834 25.6666V19.8333" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M26.834 8.1666V2.33326C26.834 1.68893 26.3116 1.1666 25.6673 1.1666H19.834" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M1.16699 19.8333V25.6666C1.16699 26.3109 1.68933 26.8333 2.33366 26.8333H8.16699" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        </g>
        <defs>
          <clipPath id="clip0_17653_77081">
            <rect width="28" height="28" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span class="popup-cursor-text hidden">Zoom Out</span>
    `;
    document.body.appendChild(popupCursor);
    if (e) {
      popupCursor.style.left = `${e.clientX}px`;
      popupCursor.style.top = `${e.clientY}px`;
    }
  };

  const updatePopupCursor = (e) => {
    if (!popupCursor) return;
    requestAnimationFrame(() => {
      if (popupCursor) {
        popupCursor.style.left = `${e.clientX}px`;
        popupCursor.style.top = `${e.clientY}px`;
      }
    });
  };

  const destroyPopupCursor = () => {
    if (popupCursor) {
      popupCursor.remove();
      popupCursor = null;
    }
  };

  const closePopup = () => {
    popup.remove();
    destroyPopupCursor();
    mediaWrapper.removeEventListener('mousemove', updatePopupCursor);
    mediaWrapper.removeEventListener('touchmove', handleTouchMove);
    mediaWrapper.removeEventListener('touchstart', handleTouchStart);
    mediaWrapper.removeEventListener('touchend', handleTouchEnd);
    if (media.tagName === 'IMG') {
      mediaWrapper.removeEventListener('mousemove', zoomImage);
      mediaWrapper.removeEventListener('mouseenter', zoomEnter);
      mediaWrapper.removeEventListener('mouseleave', zoomLeave);
      mediaWrapper.removeEventListener('click', closePopup);
    } else {
      mediaWrapper.removeEventListener('click', closePopup);
    }
  };

  const zoomEnter = (e) => {
    if (media.tagName === 'IMG' && !window.matchMedia("(max-width: 989px)").matches) {
      clone.style.opacity = '0';
      createPopupCursor(e);
    }
  };

  const zoomLeave = () => {
    if (media.tagName === 'IMG') {
      clone.style.opacity = '1';
      destroyPopupCursor();
    }
  };

  const zoomImage = (e) => {
    const rect = mediaWrapper.getBoundingClientRect();
    const offsetX = e.offsetX || (e.touches && e.touches[0].pageX) || e.clientX - rect.left;
    const offsetY = e.offsetY || (e.touches && e.touches[0].pageY) || e.clientY - rect.top;
    let x, y;
    if (e.touches) {
      if (prevTouchX !== null && prevTouchY !== null) {
        const deltaX = (prevTouchX - offsetX) / mediaWrapper.offsetWidth * 100;
        const deltaY = (prevTouchY - offsetY) / mediaWrapper.offsetHeight * 100;
        x = Math.min(Math.max(lastX + deltaX, 0), 100);
        y = Math.min(Math.max(lastY + deltaY, 0), 100);
      } else {
        x = 100 - (offsetX / mediaWrapper.offsetWidth) * 100;
        y = 100 - (offsetY / mediaWrapper.offsetHeight) * 100;
      }
      prevTouchX = offsetX;
      prevTouchY = offsetY;
    } else {
      x = (offsetX / mediaWrapper.offsetWidth) * 100;
      y = (offsetY / mediaWrapper.offsetHeight) * 100;
    }
    mediaWrapper.style.backgroundPosition = `${x}% ${y}%`;
    lastX = x;
    lastY = y;
  };

  const handleTouchStart = (e) => {
    if (media.tagName !== 'IMG' || !window.matchMedia("(max-width: 989px)").matches) return;
    if (e.touches.length === 2) {
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      initialPinchDistance = Math.hypot(
        touch1.pageX - touch2.pageX,
        touch1.pageY - touch2.pageY
      );
      prevTouchX = null;
      prevTouchY = null;
    } else if (e.touches.length === 1) {
      prevTouchX = e.touches[0].pageX - mediaWrapper.getBoundingClientRect().left;
      prevTouchY = e.touches[0].pageY - mediaWrapper.getBoundingClientRect().top;
    }
    clone.style.opacity = '0';
  };

  const handleTouchMove = (e) => {
    if (media.tagName !== 'IMG' || !window.matchMedia("(max-width: 989px)").matches) return;
    e.preventDefault();
    if (e.touches.length === 1) {
      zoomImage(e);
    } else if (e.touches.length === 2) {
      const touch1 = e.touches[0];
      const touch2 = e.touches[1];
      const currentDistance = Math.hypot(
        touch1.pageX - touch2.pageX,
        touch1.pageY - touch2.pageY
      );
      if (initialPinchDistance) {
        const scale = currentDistance / initialPinchDistance;
        currentBackgroundSize = Math.min(Math.max(initialBackgroundSize * scale, 100), 400);
        mediaWrapper.style.backgroundSize = `${currentBackgroundSize}%`;
        if (currentBackgroundSize < 160) {
          closePopup();
        }
      }
    }
  };

  const handleTouchEnd = () => {
    if (media.tagName !== 'IMG' || !window.matchMedia("(max-width: 989px)").matches) return;
    initialPinchDistance = null;
    initialBackgroundSize = currentBackgroundSize;
    prevTouchX = null;
    prevTouchY = null;
  };

  if (media.tagName === 'IMG') {
    content.style.overflow = 'hidden';
    content.style.position = 'relative';
    mediaWrapper.style.position = 'relative';
    mediaWrapper.style.backgroundSize = '160%';

    mediaWrapper.addEventListener('mouseenter', zoomEnter);
    mediaWrapper.addEventListener('mousemove', updatePopupCursor);
    mediaWrapper.addEventListener('mousemove', zoomImage);
    mediaWrapper.addEventListener('mouseleave', zoomLeave);
    mediaWrapper.addEventListener('touchstart', handleTouchStart, { passive: false });
    mediaWrapper.addEventListener('touchmove', handleTouchMove, { passive: false });
    mediaWrapper.addEventListener('touchend', handleTouchEnd);
    mediaWrapper.addEventListener('click', closePopup);
  } else {
    mediaWrapper.addEventListener('click', closePopup);
  }

  closeBtn.addEventListener('click', closePopup);
  popup.addEventListener('click', (e) => {
    if (e.target === popup) closePopup();
  });
}

initMobileSwiper() {
  const container = this.querySelector(".pdp-media-sm");
  if (!container) return;

  const mainSwiperEl = container.querySelector(".main-swiper");
  const thumbSwiperEl = container.querySelector(".thumb-swiper");
  if (!mainSwiperEl || !thumbSwiperEl) return;

  const slides = mainSwiperEl.querySelectorAll(".swiper-slide");
  const sliderLength = slides.length;

  this.thumbSwiper = new Swiper(thumbSwiperEl, {
    slidesPerView: 5,
    spaceBetween: 10,
    watchSlidesProgress: true,
    freeMode: true,
    breakpoints: {
      320: { slidesPerView: 5.5, spaceBetween: 8 },
      640: { slidesPerView: 7, spaceBetween: 10 },
      1024: { slidesPerView: 8, spaceBetween: 12 },
    },
  });

  this.mobileSwiper = new Swiper(mainSwiperEl, {
    navigation: {
      nextEl: container.querySelector(".swiper-button-prev"),
      prevEl: container.querySelector(".swiper-button-next"),
    },
    pagination: {
      el: container.querySelector(".swiper-pagination"),
      clickable: true,
    },
    thumbs: {
      swiper: this.thumbSwiper,
    },
    on: {
      init: function () {
        const totalEl = container.querySelector(".total");
        const currentEl = container.querySelector(".current");
        if (totalEl) totalEl.textContent = this.slides.length;
        if (currentEl) currentEl.textContent = this.realIndex + 1;

        if (sliderLength < 7) {
          const paginationEl = container.querySelector(".swiper-pagination");
          if (paginationEl) {
            paginationEl.classList.add("justify-center");
          }
        }
      },
      slideChange: function () {
        const currentEl = container.querySelector(".current");
        if (currentEl) currentEl.textContent = this.realIndex + 1;
      },
    },
  });
}

  /*
  initZoomSlider(){
    this.LBcursorEl = this.querySelector(".custom-zoom-cursor");
    this.addEventListener("click", this.handleClickeEvents.bind(this));

    if (this.querySelector(".media__lightbox-swiper")) {
      this.querySelector(".media__lightbox-swiper").addEventListener(
        "mouseenter",
        (e) => {
          if (this.querySelector(".media__lightbox-swiper .zoomed")) {
            this.querySelector(".custom-zoom-cursor").style.display = "none";
            document.body.style.cursor = "";
          } else {
            this.querySelector(".custom-zoom-cursor").style.display = "flex";
            this.querySelector(".custom-zoom-cursor").style.color = "red";
            document.body.style.cursor = "none";
          }
        }
      );
      this.querySelector(".media__lightbox-swiper").addEventListener(
        "mouseleave",
        (e) => {
          this.querySelector(".custom-zoom-cursor").style.display = "none";
          document.body.style.cursor = "";
        }
      );

      this.querySelector(".media__lightbox-swiper").addEventListener(
        "click",
        (e) => {
          let targetItem = e.target.classList.contains("swiper-slide")
            ? e.target
            : e.target.closest(".swiper-slide");
          if (targetItem) {
            const mediaId = targetItem.getAttribute("data-media");
            let targetMediaSlide = this.querySelector(
              `.media__lightbox-swiper .swiper-slide[data-media='${mediaId}']`
            );
            if (targetMediaSlide) {
              this.handleLBZoom(targetMediaSlide);
            }
          }
        }
      );
    }

    document.addEventListener(
      "mousemove",
      this.handleMouseMoveEvents.bind(this)
    );
  }
  */  

  /*
  handleEvents() {
    this.querySelector("form").addEventListener(
      "submit",
      this.handleAddToCart.bind(this)
    );
  }
  */

  handleEvents() {
    const form = this.querySelector('form[action$="/cart/add"]');
    if (!form) return;

    if (this._boundHandleAddToCart) {
      form.removeEventListener('submit', this._boundHandleAddToCart);
    }

    this._boundHandleAddToCart = this.handleAddToCart.bind(this);
    form.addEventListener('submit', this._boundHandleAddToCart);
  }

  handleClickeEvents(e) {
    let targetItem = e.target.classList.contains("pdp-media")
      ? e.target
      : e.target.closest(".pdp-media");
    if (targetItem) {
      const mediaId = targetItem.getAttribute("data-media");
      this.initLightBoxSlider(mediaId);
      this.querySelector(".media__lightbox").classList.add("active");
    }

    let LBcloseBtn = e.target.classList.contains("close-lightbox")
      ? e.target
      : e.target.closest(".close-lightbox");
    if (LBcloseBtn) {
      this.querySelector(".media__lightbox").classList.remove("active");
    }
  }

  handleMouseMoveEvents(e) {
    this.LBcursorEl.style.left = e.clientX - 12 + "px";
    this.LBcursorEl.style.top = e.clientY - 12 + "px";
  }

  initLightBoxSlider(mediaId) {
    this.LBgalleryThumbs = new Swiper(".media__lightbox-thumb", {
      slidesPerView: 6,
      spaceBetween: 10,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        990: {
          direction: "vertical",
        },
      },
    });

    let initIndex = 0;
    let targetMediaSlide = this.querySelector(
      `.media__lightbox-swiper .swiper-slide[data-media='${mediaId}']`
    );
    if (targetMediaSlide) {
      initIndex = parseInt(targetMediaSlide.dataset.index) || 0;
      initIndex--;
    }
    this.LBgalleryTop = new Swiper(".media__lightbox-swiper", {
      spaceBetween: 10,
      initialSlide: initIndex,
      thumbs: {
        swiper: this.LBgalleryThumbs,
      },
    });
  }

  handleLBZoom(activeSlide) {
    activeSlide.classList.toggle("zoomed");

    if (activeSlide.classList.contains("zoomed")) {
      this.querySelector(".custom-zoom-cursor").style.display = "none";
      this.querySelector(".custom-zoom-cursor").style.color = "red";
      document.body.style.cursor = "none";
    } else {
      this.querySelector(".custom-zoom-cursor").style.display = "flex";
      document.body.style.cursor = "";
    }

    this.handleLBImageMagnify(activeSlide);
  }

  handleLBImageMagnify(slide) {
    slide.addEventListener("mousemove", (e) => {
      let img = slide.querySelector("img");
      const rect = slide.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
    });
  }

  accordionInit() {
    if (this.querySelector(".accordion-wrapper-pinfo"))
      new Accordion(".accordion-wrapper-pinfo", {
        closeAll: true,
        initOpenIndex: 1,
        duration: 700,
        activeClass: "active",
      });
  }


  /*
  handleOptions(url) {
    this.fetchData(url);
    this.updateURL(url);
  }
  */

  handleOptions(url, isColorInput = true) {
    this.fetchData(url, isColorInput);
    this.updateURL(url);
  }


  async fetchData(url, isColorInput = true) {
    if (this.querySelector("pinfo-variant-picker")) {
      this.querySelector("pinfo-variant-picker").style.pointerEvents = "none";
      this.querySelector("pinfo-variant-picker").classList.add("loading");
    }
    let sectionUrl = `${url}&section_id=${this.sectionId}`;
    const response = await fetch(sectionUrl);
    const data = await response.text();
    const html = new DOMParser().parseFromString(data, "text/html");
    this.renderEl(html, isColorInput);

    
  }


  /*
  renderEl(html, isColorInput = true) {

      const hasCustomizer = !!document.querySelector('.customizer-groups-container');

      // Save the current quantity value before any DOM updates
      const currentQtyInput = this.querySelector('.qty-input');
      const currentQtyValue = currentQtyInput ? currentQtyInput.value : '1';

      if (this.querySelector(".pinfo-top") && html.querySelector(".pinfo-top")) {
        this.querySelector(".pinfo-top").innerHTML =
          html.querySelector(".pinfo-top").innerHTML;
      }

      const variantPickers = this.querySelectorAll("pinfo-variant-picker");
      const htmlVariantPickers = html.querySelectorAll("pinfo-variant-picker");

      variantPickers.forEach((picker, index) => {
        if (htmlVariantPickers[index]) {
          picker.innerHTML = htmlVariantPickers[index].innerHTML;
        }
      });

      const prices = this.querySelectorAll(".pinfo-price-wrapper");
      const htmlprices = html.querySelectorAll(".pinfo-price-wrapper");

      prices.forEach((price, index) => {
        if (htmlprices[index]) {
          price.innerHTML = htmlprices[index].innerHTML;
        }
      });

      if (
        this.querySelector(".--inventory-status-wrapper") &&
        html.querySelector(".--inventory-status-wrapper")
      ) {
        this.querySelector(".--inventory-status-wrapper").innerHTML = html.querySelector(
          ".--inventory-status-wrapper"
        ).innerHTML;
      }

      if (
        this.querySelector(".--embroidery-message-container") &&
        html.querySelector(".--embroidery-message-container")
      ) {
        this.querySelector(".--embroidery-message-container").innerHTML = html.querySelector(
          ".--embroidery-message-container"
        ).innerHTML;
      }

      if (
        this.querySelector(".pd-shipping__info") &&
        html.querySelector(".pd-shipping__info")
      ) {
        this.querySelector(".pd-shipping__info").innerHTML = html.querySelector(
          ".pd-shipping__info"
        ).innerHTML;
      }

      if (
        this.querySelector(".pd-gurantee__info") &&
        html.querySelector(".pd-gurantee__info")
      ) {
        this.querySelector(".pd-gurantee__info").innerHTML = html.querySelector(
          ".pd-gurantee__info"
        ).innerHTML;
      }

      if (
        document.querySelector(".product-details-new") &&
        html.querySelector(".product-details-new")
      ) {
        document.querySelector(".product-details-new").innerHTML =
          html.querySelector(".product-details-new").innerHTML;
      }

      if (
        this.querySelector(".--discount-code-container") &&
        html.querySelector(".--discount-code-container")
      ) {
        this.querySelector(".--discount-code-container").innerHTML =
          html.querySelector(".--discount-code-container").innerHTML;
      }

      if (this.querySelector(".pinfo-form-wrapper") && html.querySelector(".pinfo-form-wrapper")) {
        const newFormWrapper = html.querySelector(".pinfo-form-wrapper");
        const addToCartBtn = newFormWrapper.querySelector(".pinfo-add-to-cart");

        const masterContainer = document.querySelector(
          'form[action$="/cart/add"] .customizer-properties'
        );
        const savedPropsHTML = masterContainer ? masterContainer.innerHTML : null;

        this.querySelector(".pinfo-form-wrapper").innerHTML = newFormWrapper.innerHTML;

        if (savedPropsHTML) {
          const form = this.querySelector('.pinfo-form-wrapper form[action$="/cart/add"]');
          if (form) {
            let propsContainer = form.querySelector('.customizer-properties');
            if (!propsContainer) {
              propsContainer = document.createElement('div');
              propsContainer.className = 'customizer-properties';
              propsContainer.style.display = 'none';
              form.appendChild(propsContainer);
            }
            propsContainer.innerHTML = savedPropsHTML;
          }
        } else if (hasCustomizer) {
          const form = this.querySelector('.pinfo-form-wrapper form[action$="/cart/add"]');
          if (form) {
            let propsContainer = form.querySelector('.customizer-properties');
            if (!propsContainer) {
              propsContainer = document.createElement('div');
              propsContainer.className = 'customizer-properties';
              propsContainer.style.display = 'none';
              form.appendChild(propsContainer);
            }
            if (typeof window.__customizerWriteProperties === 'function') {
              window.__customizerWriteProperties();
            }
          }
        }

        const liveContainer = document.querySelector(".pinfo-form-container");
        if (liveContainer) {
          const liveQty = liveContainer.querySelector(".quantity-selector-wrapper");
          if (addToCartBtn && addToCartBtn.classList.contains("hidden")) {
            liveContainer.classList.add("pinfo-form-one-way");
            if (liveQty) liveQty.classList.add("hidden");
          } else {
            liveContainer.classList.remove("pinfo-form-one-way");
            if (liveQty) liveQty.classList.remove("hidden");
          }
        }

        if (hasCustomizer) {
          document.querySelectorAll('.pinfo-add-to-cart').forEach(btn => {
            btn.disabled = true;
            btn.setAttribute('disabled', 'disabled');
          });
          document.querySelectorAll('.p-info-btn-buy-now').forEach(btn => {
            btn.disabled = true;
            btn.setAttribute('disabled', 'disabled');
          });

          if (typeof window.__customizerRecheck === 'function') {
            window.__customizerRecheck();
          }
        }
      }

      if (isColorInput || !hasCustomizer) {
        if (
          this.querySelector("product-info-media") &&
          html.querySelector("product-info-media")
        ) {
          this.querySelector("product-info-media").innerHTML =
            html.querySelector("product-info-media").innerHTML;
        }

        if (
          this.querySelector(".media__lightbox") &&
          html.querySelector(".media__lightbox")
        ) {
          this.querySelector(".media__lightbox").innerHTML =
            html.querySelector(".media__lightbox").innerHTML;
        }
      }

      if (document.querySelector("pqa-new")) {
        document.querySelector("pqa-new").innerHTML =
          html.querySelector("pqa-new").innerHTML;
      }

      this.handleEvents();

      if (this.querySelector("pinfo-variant-picker")) {
        this.querySelector("pinfo-variant-picker").style.pointerEvents = "unset";
        this.querySelector("pinfo-variant-picker").classList.remove("loading");
      }

      if (document.querySelector("stock-notify")) {
        if (typeof notifyPopup === "function") {
          notifyPopup();
        }
      }
      
      this.initMobileSwiper();

      if (typeof initializeProductDrawers === "function") {
        initializeProductDrawers();
      }
      if (typeof productDrawerTab === "function") {
        productDrawerTab();
      }
      if (typeof initRelatedVariant === "function") {
        initRelatedVariant();
      }

      this.verticalImageChange();
      this.customCursor();
      this.mediaPopup();
      this.colorLabelHover();
      this.optionLabelHover();
      this.handleActionPopup();

      // Re-initialize quantity selector
      this.initQuantitySelector();

      // Restore the previous quantity value
      const newQtyInput = this.querySelector('.qty-input');
      if (newQtyInput && currentQtyValue) {
        newQtyInput.value = currentQtyValue;
        // Also dispatch the quantity change event to update any dependent components
        this.dispatchQuantityChange(parseInt(currentQtyValue));
      }

      if (typeof window.setupSectionNavigatorScroll === "function") {
        window.setupSectionNavigatorScroll();
      }
      if (typeof window.enableStickyATC === "function") {
        window.enableStickyATC();
      }
      if (typeof window.sizeGuide === "function") {
        window.sizeGuide();
      }
      if (typeof window.notifyButtons === "function") {
        window.notifyButtons();
      }

      if (isColorInput && typeof window.appCustomizer === "function") {
        window.appCustomizer();
      }

      if (typeof window.globalAtcRemoveFunc === "function") {
        window.globalAtcRemoveFunc();
      }
      
      yotpoWidgetsContainer.initWidgets();

      if (window.CustomPlacement && window.CustomPlacement.instance) {
        window.CustomPlacement.instance.reattachEventListeners();
        window.CustomPlacement.instance.recheckState();
      }

      // Dispatch variant:change event
      const variantId = this.querySelector('input[name="id"]')?.value;
      if (variantId) {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId } }));
      }
  }
  */
 


 renderEl(html, isColorInput = true) {
    // Helper function to safely call app customizer recheck
    function recheckAppCustomizer() {
      var recheckFn = window.__appCustomizerRecheck || window.__customizerRecheck;
      if (typeof recheckFn === 'function') {
        setTimeout(function() {
          recheckFn();
        }, 100);
      }
    }

    // Check if either customizer exists on the page
    const hasCustomizer = !!document.querySelector('.customizer-groups-container');
    const hasPlacement = !!document.querySelector('.cpc-placement-wrapper');
    const hasAnyCustomizer = hasCustomizer || hasPlacement;

    // Save current quantity value BEFORE any DOM updates
    const currentQtyInput = this.querySelector('.qty-input');
    const currentQtyValue = currentQtyInput ? currentQtyInput.value : '1';

    // ============================================================
    // UPDATE VARIANT PICKERS - ALWAYS RUN
    // ============================================================
    const variantPickers = this.querySelectorAll("pinfo-variant-picker");
    const htmlVariantPickers = html.querySelectorAll("pinfo-variant-picker");
    variantPickers.forEach((picker, index) => {
      if (htmlVariantPickers[index]) {
        picker.innerHTML = htmlVariantPickers[index].innerHTML;
      }
    });

    // ============================================================
    // UPDATE PRICES - ALWAYS RUN
    // ============================================================
    const prices = this.querySelectorAll(".pinfo-price-wrapper");
    const htmlprices = html.querySelectorAll(".pinfo-price-wrapper");
    prices.forEach((price, index) => {
      if (htmlprices[index]) {
        price.innerHTML = htmlprices[index].innerHTML;
      }
    });

    // ============================================================
    // UPDATE INVENTORY STATUS - ALWAYS RUN
    // ============================================================
    if (this.querySelector(".--inventory-status-wrapper") && html.querySelector(".--inventory-status-wrapper")) {
      this.querySelector(".--inventory-status-wrapper").innerHTML = html.querySelector(
        ".--inventory-status-wrapper"
      ).innerHTML;
    }

    // ============================================================
    // UPDATE EMBROIDERY MESSAGE - ALWAYS RUN
    // ============================================================
    if (this.querySelector(".--embroidery-message-container") && html.querySelector(".--embroidery-message-container")) {
      this.querySelector(".--embroidery-message-container").innerHTML = html.querySelector(
        ".--embroidery-message-container"
      ).innerHTML;
    }

    // ============================================================
    // UPDATE SHIPPING INFO - ALWAYS RUN
    // ============================================================
    if (this.querySelector(".pd-shipping__info") && html.querySelector(".pd-shipping__info")) {
      this.querySelector(".pd-shipping__info").innerHTML = html.querySelector(
        ".pd-shipping__info"
      ).innerHTML;
    }

    // ============================================================
    // UPDATE GUARANTEE INFO - ALWAYS RUN
    // ============================================================
    if (this.querySelector(".pd-gurantee__info") && html.querySelector(".pd-gurantee__info")) {
      this.querySelector(".pd-gurantee__info").innerHTML = html.querySelector(
        ".pd-gurantee__info"
      ).innerHTML;
    }

    // ============================================================
    // UPDATE PRODUCT DETAILS - ALWAYS RUN
    // ============================================================
    if (document.querySelector(".product-details-new") && html.querySelector(".product-details-new")) {
      document.querySelector(".product-details-new").innerHTML =
        html.querySelector(".product-details-new").innerHTML;
    }

    // ============================================================
    // UPDATE DISCOUNT CODE - ALWAYS RUN
    // ============================================================
    if (this.querySelector(".--discount-code-container") && html.querySelector(".--discount-code-container")) {
      this.querySelector(".--discount-code-container").innerHTML =
        html.querySelector(".--discount-code-container").innerHTML;
    }

    // ============================================================
    // UPDATE FORM
    // ============================================================
    if (this.querySelector(".pinfo-form-wrapper") && html.querySelector(".pinfo-form-wrapper")) {
      const newFormWrapper = html.querySelector(".pinfo-form-wrapper");
      const addToCartBtn = newFormWrapper.querySelector(".pinfo-add-to-cart");

      if (!hasAnyCustomizer) {
        this.querySelector(".pinfo-form-wrapper").innerHTML = newFormWrapper.innerHTML;

        const liveContainer = document.querySelector(".pinfo-form-container");
        if (liveContainer) {
          const liveQty = liveContainer.querySelector(".quantity-selector-wrapper");
          if (addToCartBtn && addToCartBtn.classList.contains("hidden")) {
            liveContainer.classList.add("pinfo-form-one-way");
            if (liveQty) liveQty.classList.add("hidden");
          } else {
            liveContainer.classList.remove("pinfo-form-one-way");
            if (liveQty) liveQty.classList.remove("hidden");
          }
        }
      } else {
        if (!isColorInput) {
          const newVariantInput = newFormWrapper.querySelector('input[name="id"]');
          const liveVariantInput = this.querySelector('.pinfo-form-wrapper input[name="id"]');
          if (newVariantInput && liveVariantInput) {
            liveVariantInput.value = newVariantInput.value;
          }

          const liveAddToCart = this.querySelector('.pinfo-add-to-cart');
          if (liveAddToCart && addToCartBtn) {
            liveAddToCart.textContent = addToCartBtn.textContent;
            liveAddToCart.disabled = addToCartBtn.disabled;
            if (addToCartBtn.disabled) {
              liveAddToCart.setAttribute('disabled', 'disabled');
            } else {
              liveAddToCart.removeAttribute('disabled');
            }
            liveAddToCart.className = addToCartBtn.className;
          }

          const liveBuyNow = this.querySelector('.p-info-btn-buy-now');
          const newBuyNow = newFormWrapper.querySelector('.p-info-btn-buy-now');
          if (liveBuyNow && newBuyNow) {
            liveBuyNow.href = newBuyNow.href;
            if (newBuyNow.disabled) {
              liveBuyNow.setAttribute('disabled', 'disabled');
            } else {
              liveBuyNow.removeAttribute('disabled');
            }
          }

          const liveNotify = this.querySelector('.--notfify-form-wrapper');
          const newNotify = newFormWrapper.querySelector('.--notfify-form-wrapper');
          if (liveNotify && newNotify) {
            liveNotify.dataset.variantId = newNotify.dataset.variantId;
          }

          const liveContainer = document.querySelector(".pinfo-form-container");
          if (liveContainer) {
            const liveQty = liveContainer.querySelector(".quantity-selector-wrapper");
            if (addToCartBtn && addToCartBtn.classList.contains("hidden")) {
              liveContainer.classList.add("pinfo-form-one-way");
              if (liveQty) liveQty.classList.add("hidden");
            } else {
              liveContainer.classList.remove("pinfo-form-one-way");
              if (liveQty) liveQty.classList.remove("hidden");
            }
          }

          // Recheck App Customizer
          recheckAppCustomizer();
          /*
          if (hasCustomizer && typeof window.__appCustomizerRecheck === 'function') {
            setTimeout(function() {
              window.__appCustomizerRecheck();
            }, 100);
          }
          */

          // Recheck Custom Placement
          if (hasPlacement && typeof window.__placementRecheck === 'function') {
            setTimeout(function() {
              window.__placementRecheck();
            }, 100);
          }

          // ============================================================
          // CRITICAL FIX: Re-initialize quantity selector and restore value
          // ============================================================
          this.initQuantitySelector();
          
          const newQtyInput = this.querySelector('.qty-input');
          if (newQtyInput && currentQtyValue) {
            newQtyInput.value = currentQtyValue;
            this.dispatchQuantityChange(parseInt(currentQtyValue));
          }

          this.customCursor();
          this.mediaPopup();
          this.colorLabelHover();
          this.optionLabelHover();
          this.handleActionPopup();

          if (typeof initializeProductDrawers === "function") {
            initializeProductDrawers();
          }
          if (typeof productDrawerTab === "function") {
            productDrawerTab();
          }
          if (typeof initRelatedVariant === "function") {
            initRelatedVariant();
          }

          if (document.querySelector("stock-notify") && typeof notifyPopup === "function") {
            notifyPopup();
          }

          if (typeof window.setupSectionNavigatorScroll === "function") {
            window.setupSectionNavigatorScroll();
          }
          if (typeof window.enableStickyATC === "function") {
            window.enableStickyATC();
          }
          if (typeof window.sizeGuide === "function") {
            window.sizeGuide();
          }
          if (typeof window.notifyButtons === "function") {
            window.notifyButtons();
          }

          window.globalAtcRemoveFunc();
          yotpoWidgetsContainer.initWidgets();

          const variantId = this.querySelector('input[name="id"]')?.value;
          if (variantId) {
            document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId } }));
          }

          if (this.querySelector("pinfo-variant-picker")) {
            this.querySelector("pinfo-variant-picker").style.pointerEvents = "unset";
            this.querySelector("pinfo-variant-picker").classList.remove("loading");
          }

          return;
        }

        const masterContainer = document.querySelector('form[action$="/cart/add"] .customizer-properties');
        const savedPropsHTML = masterContainer ? masterContainer.innerHTML : null;

        this.querySelector(".pinfo-form-wrapper").innerHTML = newFormWrapper.innerHTML;

        if (savedPropsHTML) {
          const form = this.querySelector('.pinfo-form-wrapper form[action$="/cart/add"]');
          if (form) {
            let propsContainer = form.querySelector('.customizer-properties');
            if (!propsContainer) {
              propsContainer = document.createElement('div');
              propsContainer.className = 'customizer-properties';
              propsContainer.style.display = 'none';
              form.appendChild(propsContainer);
            }
            propsContainer.innerHTML = savedPropsHTML;
          }
        } else if (hasCustomizer) {
          const form = this.querySelector('.pinfo-form-wrapper form[action$="/cart/add"]');
          if (form) {
            let propsContainer = form.querySelector('.customizer-properties');
            if (!propsContainer) {
              propsContainer = document.createElement('div');
              propsContainer.className = 'customizer-properties';
              propsContainer.style.display = 'none';
              form.appendChild(propsContainer);
            }
            if (typeof window.__customizerWriteProperties === 'function') {
              window.__customizerWriteProperties();
            }
          }
        }

        const liveContainer = document.querySelector(".pinfo-form-container");
        if (liveContainer) {
          const liveQty = liveContainer.querySelector(".quantity-selector-wrapper");
          if (addToCartBtn && addToCartBtn.classList.contains("hidden")) {
            liveContainer.classList.add("pinfo-form-one-way");
            if (liveQty) liveQty.classList.add("hidden");
          } else {
            liveContainer.classList.remove("pinfo-form-one-way");
            if (liveQty) liveQty.classList.remove("hidden");
          }
        }

        if (hasCustomizer) {
          document.querySelectorAll('.pinfo-add-to-cart').forEach(btn => {
            btn.disabled = true;
            btn.setAttribute('disabled', 'disabled');
          });
          document.querySelectorAll('.p-info-btn-buy-now').forEach(btn => {
            btn.disabled = true;
            btn.setAttribute('disabled', 'disabled');
          });
        }
      }
    }

    // ============================================================
    // UPDATE PRODUCT MEDIA
    // ============================================================
    if (!hasAnyCustomizer || isColorInput) {
      if (this.querySelector("product-info-media") && html.querySelector("product-info-media")) {
        this.querySelector("product-info-media").innerHTML =
          html.querySelector("product-info-media").innerHTML;
      }
      if (this.querySelector(".media__lightbox") && html.querySelector(".media__lightbox")) {
        this.querySelector(".media__lightbox").innerHTML =
          html.querySelector(".media__lightbox").innerHTML;
      }
    }

    // ============================================================
    // UPDATE PQA - ALWAYS RUN
    // ============================================================
    if (document.querySelector("pqa-new") && html.querySelector("pqa-new")) {
      document.querySelector("pqa-new").innerHTML =
        html.querySelector("pqa-new").innerHTML;
    }

    // ============================================================
    // RE-ATTACH EVENT HANDLERS - ALWAYS RUN
    // ============================================================
    this.handleEvents();

    if (this.querySelector("pinfo-variant-picker")) {
      this.querySelector("pinfo-variant-picker").style.pointerEvents = "unset";
      this.querySelector("pinfo-variant-picker").classList.remove("loading");
    }

    // ============================================================
    // RE-INITIALIZE QUANTITY SELECTOR - ALWAYS RUN (CRITICAL FIX)
    // ============================================================
    this.initQuantitySelector();
    
    const newQtyInput = this.querySelector('.qty-input');
    if (newQtyInput && currentQtyValue) {
      newQtyInput.value = currentQtyValue;
      this.dispatchQuantityChange(parseInt(currentQtyValue));
    }

    // ============================================================
    // RE-INITIALIZE COMPONENTS
    // ============================================================
    if (!hasAnyCustomizer) {
      this.initMobileSwiper();
      this.initStickyMobilePreview();
      this.verticalImageChange();
      this.customCursor();
      this.mediaPopup();
      this.colorLabelHover();
      this.optionLabelHover();
      this.handleActionPopup();
      
      if (document.querySelector("stock-notify") && typeof notifyPopup === "function") {
        notifyPopup();
      }
      if (typeof initializeProductDrawers === "function") {
        initializeProductDrawers();
      }
      if (typeof productDrawerTab === "function") {
        productDrawerTab();
      }
      if (typeof initRelatedVariant === "function") {
        initRelatedVariant();
      }
      if (typeof window.setupSectionNavigatorScroll === "function") {
        window.setupSectionNavigatorScroll();
      }
      if (typeof window.enableStickyATC === "function") {
        window.enableStickyATC();
      }
      if (typeof window.sizeGuide === "function") {
        window.sizeGuide();
      }
      if (typeof window.notifyButtons === "function") {
        window.notifyButtons();
      }
      if (typeof window.appCustomizer === "function") {
        window.appCustomizer();
      }
      
      window.globalAtcRemoveFunc();
      yotpoWidgetsContainer.initWidgets();
      
      const variantId = this.querySelector('input[name="id"]')?.value;
      if (variantId) {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId } }));
      }
      return;
    }

    if (isColorInput) {
      this.initMobileSwiper();
      this.initStickyMobilePreview();

      if (typeof initializeProductDrawers === "function") {
        initializeProductDrawers();
      }
      if (typeof productDrawerTab === "function") {
        productDrawerTab();
      }
      if (typeof initRelatedVariant === "function") {
        initRelatedVariant();
      }

      this.verticalImageChange();
      this.customCursor();
      this.mediaPopup();
      this.colorLabelHover();
      this.optionLabelHover();
      this.handleActionPopup();

      if (hasCustomizer && typeof window.appCustomizer === "function") {
        window.appCustomizer();
      }
      // Recheck App Customizer
      recheckAppCustomizer();
      /*
      if (hasCustomizer && typeof window.__appCustomizerRecheck === 'function') {
        setTimeout(function() {
          window.__appCustomizerRecheck();
        }, 100);
      }
      */

      if (hasPlacement && window.CustomPlacement && window.CustomPlacement.instance) {
        window.CustomPlacement.instance.reattachEventListeners();
        window.CustomPlacement.instance.recheckState();
      }
    } else {
      // Recheck App Customizer
      recheckAppCustomizer();
      /*
      if (hasCustomizer && typeof window.__appCustomizerRecheck === 'function') {
        setTimeout(function() {
          window.__appCustomizerRecheck();
        }, 100);
      }
      */
      if (hasPlacement && typeof window.__placementRecheck === 'function') {
        setTimeout(function() {
          window.__placementRecheck();
        }, 100);
      }
    }

    if (typeof window.setupSectionNavigatorScroll === "function") {
      window.setupSectionNavigatorScroll();
    }
    if (typeof window.enableStickyATC === "function") {
      window.enableStickyATC();
    }
    if (typeof window.sizeGuide === "function") {
      window.sizeGuide();
    }
    if (typeof window.notifyButtons === "function") {
      window.notifyButtons();
    }

    window.globalAtcRemoveFunc();
    yotpoWidgetsContainer.initWidgets();

    const variantId = this.querySelector('input[name="id"]')?.value;
    if (variantId) {
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId } }));
    }
  }



  // updateURL(url) {
  //   if (typeof url !== "string" || !url.startsWith("/")) {
  //     console.error("Invalid URL format");
  //     return;
  //   }

  //   if (this.dataset?.updateUrl === "true")
  //     window.history.pushState({}, "", url);
  // }

  updateURL(url) {
    if (this.dataset.updateUrl === "false") return null;
    
    const collectionHandle = this.dataset.collectionHandle;
    
    if (collectionHandle && this.dataset.withinCollection) {
      const urlObj = new URL(url, window.location.origin);
      const variantParam = urlObj.searchParams.get('variant');
      const productHandle = url.split('?')[0].split('/').pop();
      const newUrl = `/collections/${collectionHandle}/products/${productHandle}${variantParam ? '?variant=' + variantParam : ''}`;
      
      window.history.replaceState({}, "", newUrl);  
    } else {
      window.history.replaceState({}, "", url);   
    }
  }

  handleAddToCart(e) {
    e.preventDefault();

    let btn = this.querySelector('button[type="submit"]');
    if (btn) {
      btn.textContent = "Adding To Bag ...";
      btn.style.pointerEvents = "none";
      btn.style.opacity = ".7";
    }

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    let addToCartForm = this.querySelector('form[action$="/cart/add"]');
    let formData = new FormData(addToCartForm);

    const isQuickView = !!this.closest('.qvm-container');

    const qtyInput = this.querySelector('.quantity-selector .qty-input');
    if (qtyInput) {
      formData.set('quantity', qtyInput.value);
    }
    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (this.cart) {
          this.cart.renderContents(response);
          
          // Dispatch cart updated event
          document.dispatchEvent(new CustomEvent('cart:updated', { 
            detail: { state: response } 
          }));

        }
      })
      .finally(() => {
        if (btn) {
          btn.textContent = "Add To Bag";
          btn.style.pointerEvents = "unset";
          btn.style.opacity = "1";
        }
        
        if (isQuickView) {
          setTimeout(() => {
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }
            if (this.cart && this.cart.classList.contains('active')) {
              this.cart.close();
            }
            const pqvCloseBtn = this.closest(".qvm-container")?.querySelector('.qvm-close-btn');
            if (pqvCloseBtn) pqvCloseBtn.click();
          }, 300);
        } else {
          if (this.cart && this.cart.classList.contains("is-empty")) {
            this.cart.classList.remove("is-empty");
          }
        }
      });
  }


  initSwiperSlider() {
    if (this.gallerySwiper) this.gallerySwiper.destroy(true, true);
    this.gallerySwiper = new Swiper(".pinfo-gallery-swiper", {
      slidesPerView: 2,
      spaceBetween: 0,
      watchSlidesProgress: true,
    });

    if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);
    this.thumbSwiper = new Swiper(".pinfo-thumb-swiper", {
      slidesPerView: 1,
      thumbs: {
        swiper: this.gallerySwiper,
      },
    });
  }
}
class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("input", this.handleVariantInput.bind(this));
    this.addEventListener("change", this.handleVariantInput.bind(this));
    
    this.addEventListener("click", this.handleSubmitEvemt.bind(this));
  }

  handleVariantInput(e) {
    // const variantUrl = e.target.value;
    let variantUrl = '';
    // Check if the target is a <select> element
      if (e.target.tagName.toLowerCase() === 'select') {
        const selectedOption = e.target.selectedOptions[0]; // Get selected <option>
        console.log('Selected',selectedOption.dataset.variantUrl)
        variantUrl = selectedOption ? selectedOption.dataset.variantUrl : null;
      }


    if (variantUrl && document.querySelector("product-information")) {
      const productInfo = document.querySelector("product-information");
      productInfo.fetchData(variantUrl);
      productInfo.updateURL(variantUrl);
    }
  }

  handleSubmitEvemt(e) {
    if (e.target.closest("form")) {
      e.preventDefault();
    }

    if (e.target.tagName === "BUTTON") {
      this.handleAddToCart(e.target.closest("form"), e.target);
      // console.log(e.target.dataset.availabilty)
      // if(e.target.dataset.availabilty == 'true'){
      //   console.log('Product available');
      //   const productInfoAddtoCart = document.querySelector("product-information .pinfo-add-to-cart");
      //   productInfoAddtoCart.click();
      // } else {
      //     console.log('Product not available')    
      //     const productInfoformWrapper = document.querySelector("product-information .pinfo-variants-options.color-variant");
          
      //     productInfoformWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // }
    //   const productInfoformWrapper = document.querySelector("product-information .pinfo-variants-options.color-variant");
          
    //       productInfoformWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // }
    const productInfoformWrapper = document.querySelector("product-information");
          
          productInfoformWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }



  }

  handleAddToCart(form, btn) {
    if (!form) return;

    if (btn) {
      btn.textContent = "Adding To Bag ...";
      btn.style.pointerEvents = "none";
      btn.style.opacity = ".7";
    }

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    let formData = new FormData(form);

    const qtyInput = document.querySelector('.quantity-selector .qty-input');
    if (qtyInput) {
      formData.set('quantity', qtyInput.value);
    }

    if (this.cart) {
      formData.append(
        "sections",
        this.cart.getSectionsToRender().map((section) => section.id)
      );
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (this.cart) this.cart.renderContents(response);
      })
      .finally(() => {
        if (btn) {
          btn.textContent = "Add To Bag";
          btn.style.pointerEvents = "unset";
          btn.style.opacity = "1";
        }

        const headerCartIcon = document.querySelector(".new-header-cart-icon");
        if (headerCartIcon) headerCartIcon.click();

        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }

        initswiperincart();
      });
  }

}
// class ProductQuickAdd extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener("input", this.handleVariantInput.bind(this));
//     this.addEventListener("click", this.handleSubmitEvemt.bind(this));
//   }

//   handleVariantInput(e) {
//     const { value } = e.target;
//     if (document.querySelector("product-information"))
//       document.querySelector("product-information").handleOptions(value);
//   }

//   handleSubmitEvemt(e) {
//     if (e.target.closest("form")) {
//       e.preventDefault();
//     }

//     if (e.target.tagName === "BUTTON") {
//       this.handleAddToCart(e.target.closest("form"), e.target);
//     }
//   }

//   handleAddToCart(form, btn) {
//     if (!form) return;

//     if (btn) {
//       // btn.classList.add("loading");
//       btn.textContent = "Adding To Bag ...";
//       btn.style.pointerEvents = "none";
//       btn.style.opacity = ".7";
//     }

//     this.cart =
//       document.querySelector("cart-notification") ||
//       document.querySelector("cart-drawer");

//     let formData = new FormData(form);

//     if (this.cart) {
//       formData.append(
//         "sections",
//         this.cart.getSectionsToRender().map((section) => section.id)
//       );
//     }

//     fetch(window.Shopify.routes.root + "cart/add.js", {
//       method: "POST",
//       body: formData,
//     })
//       .then((response) => {
//         return response.json();
//       })
//       .then((response) => {
//         this.cart.renderContents(response);
//       })
//       .finally(() => {
//         if (btn) {
//           // btn.classList.remove("loading");
//           btn.textContent = "Add To Cart";
//           btn.style.pointerEvents = "unset";
//           btn.style.opacity = "1";
//         }
//         if (document.querySelector(".new-header-cart-icon"))
//           document.querySelector(".new-header-cart-icon").click();

//         if (this.cart && this.cart.classList.contains("is-empty"))
//           this.cart.classList.remove("is-empty");
//         initswiperincart();
//       });
//   }
// }

document.addEventListener("DOMContentLoaded", (e) => {
  customElements.define("product-information", ProductInformation);
  customElements.define("pqa-new", ProductQuickAdd);
});

function initDrawer({ toggleSelector, drawerSelector, closeBtnSelector }) {
  const toggleBtn = document.querySelector(toggleSelector);
  const drawer = document.querySelector(drawerSelector);
  const closeBtn = document.querySelector(closeBtnSelector);

  if (!toggleBtn || !drawer) return;

  toggleBtn.addEventListener("click", () => {
    drawer.classList.add("open");
    document.body.classList.add("active");
    console.log("Drawer opened:", drawerSelector, document.body.classList);
  });

  closeBtn?.addEventListener("click", () => {
    drawer.classList.remove("open");
    document.body.classList.remove("active");
    console.log("Drawer closed:", drawerSelector, document.body.classList);
  });
}

// Initialize drawers with config
function initializeProductDrawers() {
  initDrawer({
    toggleSelector: "[data-main-pda]",
    drawerSelector: ".product__attribute_drawer",
    closeBtnSelector: ".pa-icon__close",
  });

  initDrawer({
    toggleSelector: "[data-shiping-btn]",
    drawerSelector: ".product__shipping_drawer",
    closeBtnSelector: ".ps-icon__close",
  });

  initDrawer({
    toggleSelector: "[data-gurantee-btn]",
    drawerSelector: ".product__gurantee_drawer",
    closeBtnSelector: ".pg-icon__close",
  });
}

function productDrawerTab() {
  const tabButtons = document.querySelectorAll(".pa_tab__title .pa__title");
  const tabContents = document.querySelectorAll(".pa__tab_content");

  if (!tabButtons.length || !tabContents.length) return;

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const order = button.dataset.order;

      // Update tab active state
      document
        .querySelector(".pa_tab__title .pa__title.active")
        ?.classList.remove("active");
      button.classList.add("active");

      // Update tab content active state
      document
        .querySelector(".pa__tab_content.active")
        ?.classList.remove("active");
      document
        .querySelector(`.pa__tab_content[data-order="${order}"]`)
        ?.classList.add("active");
    });
  });
}

function initRelatedVariant() {
  const relatedVariantButtons = document.querySelectorAll(
    "[data-related-variant-btn]"
  );
  const cartDrawerNew =
    document.querySelector("mini-cart") ||
    document.querySelector("cart-drawer");

  relatedVariantButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const variantId = btn.getAttribute("data-re-variant-id");
      if (!variantId) return;

      btn.classList.add("loading");
      btn.textContent = "Adding...";
      btn.style.pointerEvents = "none";
      btn.style.color = "#1f2937";

      const formData = new FormData();

      if (cartDrawerNew) {
        formData.append(
          "sections",
          cartDrawerNew.getSectionsToRender().map((section) => section.id)
        );
      }

      formData.append("id", variantId);
      formData.append("quantity", 1);

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          cartDrawerNew.renderContents(response);
        })
        .finally(() => {
          if (btn) {
            btn.classList.remove("loading");
            btn.textContent = "Add To Bag";
            btn.style.pointerEvents = "unset";
            btn.style.opacity = "1";
          }
          if (document.querySelector(".new-header-cart-icon"))
            document.querySelector(".new-header-cart-icon").click();

          if (cartDrawerNew && cartDrawerNew.classList.contains("is-empty"))
            cartDrawerNew.classList.remove("is-empty");
        });
    });
  });
}



window.initFaqAccordions = function () {
  const faqAccordions = document.querySelectorAll(".pr-faq-item");

  const openFaqAccordion = (accordion) => {
    if (!accordion) return;
    const content = accordion.querySelector(".pr-faq-content");
    if (!content) return;
    accordion.classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };

  const closeFaqAccordion = (accordion) => {
    if (!accordion) return;
    const content = accordion.querySelector(".pr-faq-content");
    if (!content) return;
    accordion.classList.remove("active");
    content.style.maxHeight = null;
  };

  if (faqAccordions.length > 0) {
    openFaqAccordion(faqAccordions[0]);
    if (faqAccordions[1]) openFaqAccordion(faqAccordions[1]);

    faqAccordions.forEach((accordion) => {
      const header = accordion.querySelector(".pr-faq-header");
      const content = accordion.querySelector(".pr-faq-content");
      if (!header || !content) return;

      accordion.onclick = () => {
        if (content.style.maxHeight) {
          closeFaqAccordion(accordion);
        } else {
          if (window.innerWidth > 768) {
            faqAccordions.forEach((a) => closeFaqAccordion(a));
          }
          openFaqAccordion(accordion);
        }
      };
    });
  }
};


// Define the global function
window.globalAtcRemoveFunc = function () {
  document.querySelectorAll('.custom__atc-global-btn').forEach(btn => {
    btn.classList.remove('custom__atc-global-btn');
  });
};

// Run it once when the page fully loads
document.addEventListener('DOMContentLoaded', function () {
  window.globalAtcRemoveFunc();
});


// window.iconTextFunc();
// window.iconTextFuncInDrawer();
initializeProductDrawers();
productDrawerTab();
initRelatedVariant();
window.initFaqAccordions();




document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const scrollThreshold = 300;
  let isScrolled = false;

  window.addEventListener("scroll", function () {
    const shouldBeScrolled = window.scrollY > scrollThreshold;

    if (shouldBeScrolled !== isScrolled) {
      isScrolled = shouldBeScrolled;
      if (isScrolled) {
        body.classList.add("pad__bottom");
      } else {
        body.classList.remove("pad__bottom");
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  window.functionsWithRetry('handleWair');
})

/*

    window.addEventListener("click", function(e){
      if(e.target.classList.contains("pdp-media") || e.target.closest(".pdp-media")){
          window.zoomFunc();
         let targetItem = e.target.classList.contains("pdp-media")?e.target:e.target.closest(".pdp-media");
         console.log(targetItem);
         const mediaId = targetItem.getAttribute('data-media');
         openLightbox(mediaId);
      }
    })

  window.zoomFunc = function(){
    const galleryThumbs = new Swiper('.media__lightbox-thumb', {
      slidesPerView: 6,
      spaceBetween: 10,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      breakpoints: {
        990: {
          direction: 'vertical',
        },
      },
    });
  
    const galleryTop = new Swiper('.media__lightbox-swiper', {
      spaceBetween: 10,
      thumbs: {
        swiper: galleryThumbs
      },
      on: {
        slideChange: function() {
          document.querySelectorAll('.media__lightbox-swiper .swiper-slide').forEach(slide => {
            slide.classList.remove('zoomed');
            slide.style.cursor = '';
          });
        }
      }
    });
  
    const lightbox = document.querySelector('.media__lightbox');
    
    const closeBtn = document.querySelector('[close-lightbox]');
    const pdpMediaItems = document.querySelectorAll('.pdp-media');

    // window.addEventListener("click", function(e){
    //   if(e.target.classList.contains("pdp-media") || e.target.closest(".pdp-media")){
    //      let targetItem = e.target.classList.contains("pdp-media")?e.target:e.target.closest(".pdp-media");
    //      console.log(targetItem);
    //      const mediaId = targetItem.getAttribute('data-media');
    //      openLightbox(mediaId);
    //   }
    // })
    // pdpMediaItems.forEach(item => {
    //   item.addEventListener('click', function() {
    //     const mediaId = this.getAttribute('data-media');
    //     openLightbox(mediaId);
    //   });
    // });
  
    closeBtn.addEventListener('click', closeLightbox);
  
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });
  
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('active')) {
        closeLightbox();
      }
    });
  
    const customCursor = document.createElement('div');
    customCursor.className = 'custom-zoom-cursor';
    customCursor.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M12 5V19M5 12H19" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    document.body.appendChild(customCursor);
  
    customCursor.style.display = 'none';
  
    document.addEventListener('mousemove', function(e) {
      customCursor.style.left = (e.clientX - 12) + 'px';
      customCursor.style.top = (e.clientY - 12) + 'px';
    });
  
    const lightboxSlides = document.querySelectorAll('.media__lightbox-swiper .swiper-slide');
  
    lightboxSlides.forEach(slide => {
      const img = slide.querySelector('img');
  
      slide.addEventListener('mouseenter', function() {
        if (!this.classList.contains('zoomed')) {
          customCursor.style.display = 'flex';
          document.body.style.cursor = 'none';
        }
      });
  
      slide.addEventListener('mouseleave', function() {
        customCursor.style.display = 'none';
        document.body.style.cursor = '';
      });
  
      slide.addEventListener('click', function(e) {
        
        if (this.classList.contains('zoomed')) {
          this.classList.remove('zoomed');
          customCursor.style.display = 'flex';
          document.body.style.cursor = 'none';
        } else {
          console.log(this);
          this.classList.add('zoomed');
          customCursor.style.display = 'none';
          document.body.style.cursor = '';
          const rect = this.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width * 100;
          const y = (e.clientY - rect.top) / rect.height * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        }
      });
  
      slide.addEventListener('mousemove', function(e) {
        if (this.classList.contains('zoomed')) {
          const rect = this.getBoundingClientRect();
          const x = (e.clientX - rect.left) / rect.width * 100;
          const y = (e.clientY - rect.top) / rect.height * 100;
          img.style.transformOrigin = `${x}% ${y}%`;
        }
      });
    });
  
    function openLightbox(mediaId) {
      console.log("----",mediaId);
      const lightbox = document.querySelector('.media__lightbox');
      const slides = document.querySelectorAll('.media__lightbox-swiper .swiper-slide');
      console.log("----",slides);
      let slideIndex = 0;
      slides.forEach((slide, index) => {
        if (slide.getAttribute('data-media') === mediaId) {
          slideIndex = index;
        }
      });
      console.log("Light", lightbox);
      lightbox.classList.add('active');
      galleryTop.slideTo(slideIndex);
      galleryThumbs.slideTo(slideIndex);
      document.body.style.overflow = 'hidden';
      
    }
  
    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
      customCursor.style.display = 'none';
      document.body.style.cursor = '';
      document.querySelectorAll('.media__lightbox-swiper .swiper-slide').forEach(slide => {
        slide.classList.remove('zoomed');
      });
    }
  }
document.addEventListener('DOMContentLoaded', function() {
  // window.zoomFunc();
});
*/
